<template>
    <table class="table table-light rounded module-order-table mounting-rail-arrangement-table">
        <thead class="thead-dark">
        <tr>
            <th>{{ $t('Position') }}</th>
            <th>{{ $t('Article') }}</th>
            <th>{{ $t('Article no.') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="mountingRail in mountingRailArrangement" :class="mountingRail.product_subtype">
            <td>{{ mountingRail.mounting_rail_order_index }}</td>
            <td>{{ $t(mountingRail.mounting_rail_title) }}</td>
            <td>{{ mountingRail.mounting_rail_sku }}</td>
        </tr>
        </tbody>
    </table>
</template>

<script>

export default {

    props: ['product_configurator_id', 'mountingRailArrangementData', 'allApiCallsLoaded', 'emergency_light'],

    data() {
        return {
            mountingRailArrangement: [],
            mountingRailDataSet: false,
        };
    },

    mounted() {
        if (this.allApiCallsLoaded && !this.mountingRailDataSet) {
            this.setMountingRailArrangementData();
        }
    },

    methods: {

        setMountingRailArrangementData() {

            let mountingRailOrderIndex = 0;

            this.mountingRailArrangement = this.mountingRailArrangementData.map( el => {
                mountingRailOrderIndex++;

                el.mounting_rail_order_index = mountingRailOrderIndex;
                el.mounting_rail_title = el.title;
                el.mounting_rail_sku = el.sku;
                el.mounting_rail_product_id = el.product_id;
                el.mounting_rail_length = el.length;

                return el;
            });

            this.mountingRailDataSet = true;

        },

    },

    watch: {
        allApiCallsLoaded: {
            handler: function(loaded, oldVal) {
                if (loaded && !this.mountingRailDataSet) {
                    this.setMountingRailArrangementData();
                }
            },
            deep: true
        },

    },

};
</script>
